import { css } from '@genesislcap/web-core';

export const CashProDataStyles = css`
  :host {
    display: block;
    padding: 20px;
    height: 100vh;
    overflow-y: auto;
    box-sizing: border-box;
    color: var(--neutral-foreground-rest);
  }

  .grid-container {
    height: 400px;
  }
`;
